var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _c("label", [
        _vm.f.IsRequired
          ? _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
          : _vm._e(),
        _vm._v(" " + _vm._s(_vm.f.Name) + "\n        "),
        _vm.f.IsReadonly === false
          ? _c("span", [
              _vm._v("("),
              _c(
                "a",
                { staticClass: "text-primary", on: { click: _vm.addValue } },
                [_vm._v("add")]
              ),
              _vm._v(")"),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm._l(_vm.values, function (v) {
        return _c("div", { key: v.Id }, [
          _c("div", { staticClass: "input-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: v.Value,
                  expression: "v.Value",
                  modifiers: { number: true },
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                placeholder: "Number...",
                title: "Please enter number",
                readonly: _vm.f.IsReadonly === true,
                min: _vm.f.MinValue != null ? _vm.f.MinValue : null,
                max: _vm.f.MaxValue != null ? _vm.f.MaxValue : null,
                step: "any",
              },
              domProps: { value: v.Value },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(v, "Value", _vm._n($event.target.value))
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-append" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  attrs: {
                    disabled: _vm.f.IsReadonly === true,
                    type: "button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.removeValue(v)
                    },
                  },
                },
                [_c("span", { staticClass: "fa fa-times" })]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "error" }, [_vm._v(_vm._s(v.Error))]),
        ])
      }),
      _vm._v(" "),
      _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))]),
      _vm._v(" "),
      _vm.f.Description
        ? _c("small", { staticClass: "form-text text-muted" }, [
            _vm._v(_vm._s(_vm.f.Description)),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }